import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { STICKY } from "@/constants/testIds";

export default function StickyMobileCTA() {
    const { pathname } = useLocation();
    // Hide on claim form & admin pages
    if (pathname.startsWith("/claim") || pathname.startsWith("/admin")) return null;

    return (
        <div
            data-testid={STICKY.bar}
            className="lg:hidden fixed bottom-0 left-0 right-0 z-30 px-4 pb-4 pt-2 pointer-events-none"
        >
            <div className="pointer-events-auto bg-navy-900 rounded-2xl shadow-glow-emerald flex items-center justify-between px-4 py-3 border border-white/10">
                <div>
                    <div className="text-[11px] uppercase tracking-[0.18em] text-emerald-400 font-semibold">Free check · 60 sec</div>
                    <div className="text-sm text-white font-semibold">Start your claim</div>
                </div>
                <Link
                    to="/claim"
                    className="inline-flex items-center gap-1.5 bg-emerald-500 hover:bg-emerald-400 text-navy-900 font-bold text-sm px-4 py-2.5 rounded-xl transition-colors"
                >
                    Begin <ArrowRight className="w-4 h-4" />
                </Link>
            </div>
        </div>
    );
}
